import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getListEditionError() {
      return getState().error;
    },
    isListEditionRequestFailure() {
      return getState().request.isFailure;
    },
    isListEditionRequestPending() {
      return getState().request.isPending;
    },
    isListEditionRequestSuccess() {
      return getState().request.isSuccessful;
    },
  };
}

export { createSelector };
